// @copyright  2006-2022 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: '/:organisation/reports/inventory/service-price-list',
        component: () =>
            import('@/pages/[organisation]/reports/inventory/service-price-list.vue'),
        name: 'reports.inventory.service-price-list',
        meta: {
            loginRequired: true,
            permission: 'access.reports.inventory.create-service-price-list',
        },
    },
    {
        path: '/:organisation/reports/inventory/inventory-report',
        component: () =>
            import('@/pages/[organisation]/reports/inventory/inventory-report.vue'),
        name: 'reports.inventory.inventory-report',
        meta: {
            loginRequired: true,
            permission: 'access.reports.inventory.print-inventory-report',
        },
    },
];
